import * as NGL from 'ngl'
import chroma from 'chroma-js'

var scale = chroma.scale(['blue', 'green', 'yellow', 'red'])

export var bfactorColor = NGL.ColormakerRegistry.addScheme(function (params) {
  this.atomColor = function (atom) {
    return parseInt('0x' + scale(atom.bfactor).hex().substr(1))
  }
})
